import { useEffect } from 'react';
import Description from '@styles/requestViews/Description';
import TitleSection from '@styles/requestViews/TitleSection';
import LoadingBlock from '@components/RequestProject/LoadingBlock';
import useRequestMediaPermission from '@recorder/hooks/useRequestMediaPermission';
import { useRecorderContext } from '@recorder/context/recorderContext';

interface InitialProps {
  campaignStyle: {
    heading1: string;
    heading2: string;
  };
  setStatus: (status: any) => void;
}

function RequestMediaPermission({ campaignStyle, setStatus }: InitialProps) {
  const { mediaPermission } = useRecorderContext();
  const requestPermission = useRequestMediaPermission();

  useEffect(() => {
    async function init() {
      try {
        await requestPermission();
        setStatus('recording');
      } catch {
        // send to the fail screen
        setStatus('initial');
      }
    }
    if (mediaPermission) {
      setStatus('recording');
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="initial">
        <div className="initial-content">
          <LoadingBlock size="32px" style={{ position: 'relative' }} />
          <TitleSection
            style={{ maxWidth: '300px', alignSelf: 'center', marginTop: '0' }}
            color={campaignStyle.heading1}
          >
            We need microphone and camera access
          </TitleSection>
          <Description
            style={{ marginTop: '0' }}
            color={campaignStyle.heading2}
          >
            Start recording by granting us access to your microphone and camera
            by clicking allow.
          </Description>
        </div>
      </div>
      <style jsx>
        {`
          .initial {
            padding: 56px 0 56px;

            font-family: Larsseit;
            display: flex;
            justify-content: center;
            width: 512px;
            height: 456px;

            background-color: transparent;
            border: 1px solid rgba(0, 0, 0, 0.08);
            box-sizing: border-box;
            box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
            border-radius: 8px;
          }

          .initial-content {
            width: 100%;
            max-width: 336px;
            display: flex;
            justify-content: center;
            aling-item: center;
            flex-flow: column;
          }
        `}
      </style>
    </>
  );
}

export default RequestMediaPermission;
